import React, { useState } from 'react';
import { mockAuth, useFirebase } from '../services/mockDatabase';
import { Lock, Mail, AlertCircle, Sparkles } from 'lucide-react';

const Login = ({ onLoginSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const user = await mockAuth.login(email, password);
      onLoginSuccess(user);
      window.location.hash = '#/';
    } catch (err) {
      setError(err.message);
    }
  };

  const handleUseMock = (mockEmail, mockPassword) => {
    setEmail(mockEmail);
    setPassword(mockPassword);
  };

  return (
    <div className="max-w-md mx-auto my-12 p-8 bg-white rounded-3xl shadow-xl border border-pink-100">
      <div className="text-center mb-8">
        <div className="inline-flex p-3 bg-pink-100 text-pink-600 rounded-full mb-3">
          <Sparkles size={32} />
        </div>
        <h2 className="text-2xl font-bold text-gray-800">Welcome Back!</h2>
        <p className="text-gray-500 text-sm mt-1">Sign in to shop and track your orders</p>
      </div>

      {error && (
        <div className="flex items-center gap-2 bg-red-50 text-red-600 p-4 rounded-xl text-sm mb-6 border border-red-100">
          <AlertCircle size={18} />
          <span>{error}</span>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-5">
        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Email Address</label>
          <div className="relative">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
              <Mail size={18} />
            </span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-semibold text-gray-700 mb-2">Password</label>
          <div className="relative">
            <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400">
              <Lock size={18} />
            </span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              className="w-full pl-10 pr-4 py-3 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-transparent transition-all"
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-pink-500 hover:bg-pink-600 text-white font-bold py-3 px-4 rounded-xl transition-all shadow-md hover:shadow-lg transform active:scale-95"
        >
          Sign In
        </button>
      </form>

      <div className="mt-6 text-center text-sm text-gray-500">
        Don't have an account?{' '}
        <a href="#/register" className="text-pink-600 font-bold hover:underline">
          Register here
        </a>
      </div>

      {/* Mock Accounts Helper */}
      {!useFirebase && (
        <div className="mt-8 pt-6 border-t border-gray-100 bg-pink-50/30 p-4 rounded-2xl">
          <h4 className="text-xs font-bold uppercase text-gray-400 tracking-wider mb-3 text-center">Testing Mock Accounts</h4>
          <div className="grid grid-cols-2 gap-2 text-xs">
            <button
              onClick={() => handleUseMock('customer@beadboutique.com', 'customer123')}
              className="p-3 bg-white border border-pink-100 hover:border-pink-300 rounded-xl text-left hover:shadow-sm transition-all"
            >
              <span className="block font-bold text-gray-700">Customer Role</span>
              <span className="block text-gray-500 mt-1">customer@beadboutique.com</span>
              <span className="block text-gray-400">Pass: customer123</span>
            </button>
            <button
              onClick={() => handleUseMock('admin@beadboutique.com', 'admin123')}
              className="p-3 bg-white border border-pink-100 hover:border-pink-300 rounded-xl text-left hover:shadow-sm transition-all"
            >
              <span className="block font-bold text-gray-700">Admin (Georgia)</span>
              <span className="block text-gray-500 mt-1">admin@beadboutique.com</span>
              <span className="block text-gray-400">Pass: admin123</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
